import { createRandomStringGenerator } from "@better-auth/utils/random";
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { mapToSqliteType } from "@ocr-monorepo/sql-utils";

export { mapToSqliteType };
export function sanitizeName(input: string): string {
  return input.replace(/[^a-zA-Z0-9_-]/g, "_");
}

export const generateRandomString = createRandomStringGenerator(
  "A-Z",
  "0-9",
  "a-z",
  "-_",
);

export function chunkArray<T>(arr: T[], size: number = 50): T[][] {
  if (size <= 0) {
    throw new Error("size must be greater than 0");
  }

  const chunks: T[][] = [];

  for (let i = 0; i < arr.length; i += size) {
    chunks.push(arr.slice(i, i + size));
  }

  return chunks;
}
export function formatFileSize(bytes: number): string {
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return (
    Number.parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i]
  );
}

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
